import {
  Benchmark,
  BenchmarkReportClient,
  ClientOutput,
} from '../../Clients/BenchmarkReportClient';
import { call, put } from 'redux-saga/effects';
import { ApiGetter } from '../../Clients/ApiGetter';
import { actions } from '../../../reducers/Dashboard/BenchmarkStandings';

export const benchmarkReportClient = new BenchmarkReportClient(new ApiGetter());

interface GetBenchmarkStandingsAction {
  organizationUUID: string;
}

export function* getBenchmarkStandings({
  organizationUUID,
}: GetBenchmarkStandingsAction) {
  const { data, error }: ClientOutput = yield call(
    [benchmarkReportClient, benchmarkReportClient.retrieveAsync],
    organizationUUID
  );

  if (error) {
    yield put(actions.setBenchmarks(undefined));
  }

  const benchmarks = [
    data?.authorTestsDistribution,
    data?.codeReviewLifecycleDuration,
    data?.codeReviewSize,
    data?.issueCatchRate,
    data?.reviewerResponseLatency,
  ].filter((benchmark) => benchmark !== undefined) as Benchmark[];

  if (benchmarks.length === 0) {
    yield put(actions.setBenchmarks(undefined));
  }

  yield put(actions.setBenchmarks(benchmarks));
}
